<template>
    <el-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        title="编辑"
        width="800px"
        append-to-body
        :before-close="handleClose">
        <div slot="title">
            <p>编辑
                <span class="sub-title ml10 text-color-gray font12px">{{data[tabType+'_name']}}</span>
            </p>
        </div>
        <div class="content-wrap">
            <el-form ref="form" :model="formItem" :rules="rules"  @submit.native.prevent label-width="150px" v-loading="formLoading">
                <el-form-item v-for="item in formGroupList" :label="item.label+'：'" :key="item.name" class="mb8">
                    <template v-if="item.type=='content'">
                        <el-input
                            v-model="formItem[item.name]"
                            clearable
                            placeholder="请输入"
                            :maxlength="50"
                            class="word-limit-input"
                            style="width: 300px;">
                        </el-input>
                        <span class="ml10 font12px text-color-gray">{{formItem[item.name].length}}/50</span>
                    </template>
                    <el-radio-group v-else-if="item.type=='select'&&item.source=='user_system'" v-model="formItem[item.name]">
                        <el-radio v-for="inner in item.options" :key="inner.id" :label="inner.id">{{inner.name}}</el-radio>
                    </el-radio-group>
                    <ESelect
                        v-else-if="item.type=='select'&&item.source=='user'"
                        v-model="formItem[item.name]"
                        multiple
                        filterable
                        :multiple-limit="+item.max_allow_num||0"
                        placeholder="请选择"
                        style="width: 300px;">
                        <el-option
                            v-for="inner in item.options"
                            :key="inner.id"
                            :label="inner.name"
                            :value="inner.id">
                            {{inner.name}}
                        </el-option>
                    </ESelect>
                    <p v-if="item.type=='select'&&item.source=='user_system'" class="text-color-gray font12px">若需要恢复系统自动设置，请选择【去除人工设置】</p>

                </el-form-item>

                <el-form-item v-if="formGroupList.length<=0&&!formLoading">
                    <p class="text-color-gray">无可编辑的字段权限</p>
                </el-form-item>
            </el-form>

        </div>
        <div slot="footer" class="dialog-footer tac">
            <el-button type="default" @click="handleClose" class="action-btn mr20" v-matomo="{behaviorCategory: '标签管理('+apiTypeName+')',name: '列表(编辑-取消)' }">取消</el-button>
            <el-button type="primary" @click="handleSubmit" :loading="submitLoading" class="action-btn ml20" v-matomo="{behaviorCategory: '标签管理('+apiTypeName+')',name: '列表(编辑-提交)' }">保存</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import API from '@/api/baseInfo/tag.js';
    import matomoFun from "@/utils/matomo.js";
    export default {
        name: "SingleEditModal",
        props:{
            data:Object,
            tabType:String,
            formList:Array,
            apiTypeName:String,
        },
        components:{
        },
        data(){
            return {
                dialogVisible:false,
                submitLoading:false,
                formOptionsLoading:{},
                formGroupList:[],
                formItem:{},
                rules:{},
            }
        },
        computed:{
            formLoading(){
                return Object.values(this.formOptionsLoading).some(item=>item===true);
            },
        },
        methods:{
            showModal(){
                this.dialogVisible = true;
                this.$nextTick(()=>{
                    let formList = this.formList||[];
                    let selectList = formList.filter(item=>item.source=='user_system');
                    let selectMulList = formList.filter(item=>item.source=='user');
                    let content = formList.filter(item=>item.type=='content');
                    this.formGroupList = ([].concat(selectList,selectMulList,content)).map(item=>{
                        item.options = [];
                        return item;
                    });

                    content.forEach(item=>{
                        this.$set(this.formItem,item.name,this.data[item.name]||'');
                    });

                    [].concat(selectList,selectMulList).forEach(item=>{
                        if(item.source=='user'){
                            let itemVal = this.data[item.name];
                            this.$set(this.formItem,item.name,itemVal?itemVal.split(','):[]);
                        }else if(item.source=='user_system'){
                            let userVal = this.data[item.name+'_user'];
                            let systemVal = this.data[item.name+'_system'];
                            this.$set(this.formItem,item.name,userVal||systemVal||'');
                        }

                        this.$set(this.formOptionsLoading,item.name,true);
                        API.getSearchList({
                            apiType:this.tabType,
                            search_type:item.name,
                            search_for:'edit',
                        }).then(res=>{

                            let resData = res.data||{};
                            this.$set(item,'options',resData.list||[]);
                            this.$set(item,'max_allow_num',resData.max_allow_num);
                            this.$set(this.formOptionsLoading,item.name,false);
                        },err=>{
                            console.log('getSearchList err',err);
                            this.$set(this.formOptionsLoading,item.name,false);
                        });
                    })
                })
            },
            handleClose() {
                matomoFun.trackEvent('标签管理('+this.apiTypeName+')', '点击', '列表(编辑-取消)');
                this.dialogVisible = false;
                this.resetForm();
            },
            hideModal(){
                this.handleClose();
                this.$emit('close');
            },
            resetForm(){
                console.log('resetForm');
            },
            handleSubmit(){
                console.log('handleSubmit');

                let reqData = {};
                reqData.apiType = this.tabType;
                if(this.tabType=='subproject'){
                    reqData.plat_id_subitem_id = [this.data.plat_id+'#*||*#'+this.data.subitem_id];
                }else if(this.tabType=='plan'){
                    reqData.plat_id_plan_id = [this.data.plat_id+'_'+this.data.plan_id];
                }else if(this.tabType=='account'){
                    reqData.plat_id_account_id = [this.data.plat_id+'_'+this.data.account_id];
                }else if(this.tabType=='company'){
                    reqData.customer_id = [this.data.customer_id];
                }else if(this.tabType=='bloc'){
                    reqData.bloc_id = [this.data.bloc_id];
                }else if(this.tabType=='project'){
                    reqData.project_id = [this.data.project_id];
                }else if(this.tabType=='platusername'){
                    reqData.plat_id_plat_username = [this.data.plat_id+'_'+this.data.plat_username];
                }

                for(let item in this.formItem){
                    reqData[item] = Array.isArray(this.formItem[item])?this.formItem[item].join(','):this.formItem[item];
                }
                this.submitLoading = true;
                API.saveTag(reqData).then(res=>{
                    console.log('save tag',res);
                    this.submitLoading = false;
                    this.$message.success(res.info||'操作成功');
                    this.$emit('update');
                    this.hideModal();

                },err=>{
                    console.log('save tag err',err);
                    this.submitLoading = false;
                    this.$message.error(err.info||'操作失败');
                })
            },

        },
    }
</script>

<style lang="scss" scoped>

    .content-wrap{
        max-height: 360px;
        overflow-y: auto;
    }
</style>
